<template>
  <div>
    <asc-spinner-wrapper :loading="loading">
      <asc-details-item
        v-for="item in values"
        :key="item.title"
        :title="item.title"
        :value="item.value"
      ></asc-details-item>
    </asc-spinner-wrapper>
    <asc-no-data v-if="isEmpty"></asc-no-data>
  </div>
</template>

<script>
import AscDetailsItem from './AscDetailsItem'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscNoData from '@/components/atoms/AscNoData'

export default {
  name: 'AscDetailsList',

  components: {
    AscDetailsItem,
    AscSpinnerWrapper,
    AscNoData,
  },

  props: {
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isEmpty() {
      return !this.loading && this.values.length === 0
    },
  },
}
</script>
